export default [
  // 绘画
  {
    value: 'painting',
    label: 'creationCategoryOptions.painting'
  },
  // 视频
  {
    value: 'video',
    label: 'creationCategoryOptions.video'
  },
  // 写作
  {
    value: 'writing',
    label: 'creationCategoryOptions.writing'
  },
  // 游戏
  {
    value: 'game',
    label: 'creationCategoryOptions.game'
  },
  // 音乐
  {
    value: 'music',
    label: 'creationCategoryOptions.music'
  },
  // 播客
  {
    value: 'podcast',
    label: 'creationCategoryOptions.podcast'
  },
  // 摄影
  {
    value: 'photography',
    label: 'creationCategoryOptions.photography'
  },
  // 技术
  {
    value: 'technology',
    label: 'creationCategoryOptions.technology'
  },
  // Vtuber
  {
    value: 'vtuber',
    label: 'creationCategoryOptions.vtuber'
  },
  // 舞蹈
  {
    value: 'dance',
    label: 'creationCategoryOptions.dance'
  },
  // 体育
  {
    value: 'physicalEducation',
    label: 'creationCategoryOptions.physicalEducation'
  },
  // 旅游
  {
    value: 'tourism',
    label: 'creationCategoryOptions.tourism'
  },
  // 美食
  {
    value: 'food',
    label: 'creationCategoryOptions.food'
  },
  // 时尚
  {
    value: 'fashion',
    label: 'creationCategoryOptions.fashion'
  },
  // 数码
  {
    value: 'digital',
    label: 'creationCategoryOptions.digital'
  },
  // 动画
  {
    value: 'animation',
    label: 'creationCategoryOptions.animation'
  },
  // 翻译
  {
    value: 'translation',
    label: 'creationCategoryOptions.translation'
  },
  // 星座
  {
    value: 'astrology',
    label: 'creationCategoryOptions.astrology'
  },
  // 漫画
  {
    value: 'comics',
    label: 'creationCategoryOptions.comics'
  },
  // 艺术
  {
    value: 'art',
    label: 'creationCategoryOptions.art'
  },
  // 科普
  {
    value: 'popularScience',
    label: 'creationCategoryOptions.popularScience'
  },
  // 教育
  {
    value: 'education',
    label: 'creationCategoryOptions.education'
  },
  // 其他
  {
    value: 'other',
    label: 'creationCategoryOptions.other'
  }
]
